import { render } from "./MessageView.vue?vue&type=template&id=67962963"
import script from "./MessageView.vue?vue&type=script&lang=js"
export * from "./MessageView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\amirhossein\\Project\\emad_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__